

















































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';

import { api2 } from '@/libs/api';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import hasPermission from '@/libs/permission';
import numberFormat from '@/libs/numberFormat';
import Button from '@/components/Button.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    AddIcon,
    Loader,
    SearchField,
    Table,
    SearchIcon,
    TableBody,
    Row,
    Header,
    Cell,
    Button,
    Pagination,
    FormInput,
    ActionPopup,
    ScrollbarWrapper,
  },
  methods: {
    numberFormat,
    hasPermission,
  },
})
export default class BankConfiguration extends Vue {
  numberFormat!: (val: number) => string;
  loading = false;
  generalSearch = '';
  data = [{ id: '', name: '', fee: '' }] || null;
  token = ''
  hasPermission!: (val: string | string[]) => boolean;
  async getData() {
    try {
      const { data } = await api2.get('/bank-topup', {
        headers: {
          token: `bearer ${this.token}`,
        },
        params: {
          query: this.generalSearch === '' ? null : this.generalSearch,
        },
      });

      this.data = data.data.map((e: any) => ({
        id: e.id,
        name: e.bank_name,
        fee: e.bank_fee,
      }));
    } catch (err) {
      console.error(err);
    }
  }

  async openDetail(id: any) {
    this.$router.push(`/bayarind/top-up/bankconfiguration/edit-bank-configuration/${id}`);
  }

  mounted() {
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.getData();
  }
}
